import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedserviceService {
  constructor(){}
  private userType = new BehaviorSubject<string>('');
  castUserType = this.userType.asObservable();

  setAccountType(user){
    this.userType.next(user);
  }
}
